﻿export default {
	verbose: false
}
